import { useCallback } from 'react';

import useListWithTempId from '@/hooks/useList/useListWithTempId';
import { FilterOperatorEnum } from '@/types/schema';

import { EMPTY_GROUP } from '../../consts';
import { FilterGroupInput, FilterInputsD1 } from '../../types';

export default function useConditions({
  filterGroup,
  setCondition,
}: {
  filterGroup: FilterGroupInput;
  setCondition: (condition: FilterGroupInput) => void;
}) {
  const onFilterChange = useCallback(
    (updatedFilters: FilterInputsD1[]) => {
      const newCondition = {
        ...filterGroup,
        filters: updatedFilters,
      };
      setCondition(newCondition);
    },
    [filterGroup, setCondition],
  );

  const [groupsWithTempId, actions] = useListWithTempId(
    filterGroup.filters as FilterInputsD1[],
    onFilterChange,
  );

  const onAddConditionGroup = useCallback(() => {
    actions.push(EMPTY_GROUP);
  }, [actions]);

  const onConditionOperatorChange = useCallback(
    (val: FilterOperatorEnum) => {
      const newCondition = {
        ...filterGroup,
        operator: val,
      };
      setCondition(newCondition);
    },
    [filterGroup, setCondition],
  );

  return {
    data: {
      groupsWithTempId,
    },
    methods: {
      onAddConditionGroup,
      onGroupChange: actions.onListInputChange,
      onConditionOperatorChange,
      onGroupDelete: actions.onDelete,
      onGroupDuplicate: actions.onDuplicate,
    },
  };
}
